var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var cio_datamodel = require("cio-datamodel");

var Editor2DModel = require("./../../editor2D/editor2DModel.js");
var DrawingStateMachine = require("./../../../abstract/stateMachines/drawingStateMachine.js");

var RectangleToolStateMachine = function (root, editorModel, selectionModel, getDataCollection, options) {
    this.root = root;
    this.getDataCollection = getDataCollection;
    this.options = options;

    DrawingStateMachine.call(this, root, editorModel, selectionModel);
};
lib_core.inherit(RectangleToolStateMachine, DrawingStateMachine);

module.exports = RectangleToolStateMachine;

RectangleToolStateMachine.prototype.createElement = function () {
    var rectangle = new cio_datamodel.RectangleData(this.startCoord,
            this.options.angle, 0, 0,
            this.options.fill, this.options.strokeWidth);

    rectangle.addTo(this.getDataCollection());

    return this.getElementInteractionModel(rectangle);
};
